import app from '../app.first';

app.JobsCrud = class extends app.Component {
    onReady () {
        $('#desired-skills').select2({
            placeholder: "Type a skill and press enter",
            allowClear: true
        });
	}
}
